import { ListenableEvent } from "../utils";
import { ERR_INVALID_ARGUMENT } from "../utils/error";
import { LengthUnit } from "../utils/number";
import { isNullOrEmpty } from "../utils/string";
export class I18nManager {
    get locale() {
        return (this.mLocale);
    }
    get language() {
        return (this.mLanguage);
    }
    get lengthUnit() {
        return (this.mLengthUnit);
    }
    constructor() {
        this.eventLocaleChanged = new ListenableEvent(this);
        this.eventLanguageChanged = new ListenableEvent(this);
        this.eventLengthUnitChanged = new ListenableEvent(this);
        this.mLocale = "en-US";
        this.mLanguage = "en";
        this.mLengthUnit = LengthUnit.Meter;
    }
    setLocale(pLocale) {
        if (isNullOrEmpty(pLocale))
            throw new Error(ERR_INVALID_ARGUMENT);
        this.mLocale = pLocale;
        this.eventLocaleChanged.trigger();
    }
    setLanguage(pLanguage) {
        if (isNullOrEmpty(pLanguage))
            throw new Error(ERR_INVALID_ARGUMENT);
        this.mLanguage = pLanguage;
        this.eventLanguageChanged.trigger();
    }
    setLengthUnit(pUnit) {
        if (pUnit == null)
            return;
        this.mLengthUnit = pUnit;
        this.eventLengthUnitChanged.trigger();
    }
}
